import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { orderBy } from 'lodash/fp';
import { CalculatorIcon, Typography, UnicodeEntity } from '../../../ui-kit';
// import { routePaths } from '../../../routePaths';
import { usePriceService } from '../../../utils/hooks/priceService';
import { useDateTimeService } from '../../../utils/hooks/dateTimeService';
import { useUser } from '../../../utils/hooks/auth';
import AccordionRow from './AccordionRow';
import { CurrentVenueInventoryCounts, InventoryCountDetails } from './types';

interface InventoryCountsSummaryProps {
    currentVenueInventoryCounts: CurrentVenueInventoryCounts;
    inventoryCountBalancesAmount: number;
    inventoryCountDetails: InventoryCountDetails[];
}

const InventoryCountsSummary = ({ inventoryCountBalancesAmount, inventoryCountDetails }: InventoryCountsSummaryProps) => {
    const { t } = useTranslation();
    const { user: { cultureCode, defaultCurrency: { currencyCode } } } = useUser();
    const { priceService } = usePriceService();
    const { dateTimeService } = useDateTimeService();

    // const linkUrl = routePaths.inventoryCounts;
    const sortedInventoryCounts = orderBy('endDate', 'desc', inventoryCountDetails);

    return (
        <AccordionRow
            Icon={CalculatorIcon}
            title={t('Inventory balance')}
            color='blue' amount={inventoryCountBalancesAmount}
            // linkUrl={linkUrl}
        >
            {inventoryCountDetails.length > 0
                ? sortedInventoryCounts.map(({ endDate, id, delta }) => (
                    <Box key={id} display='flex'>
                        <Typography variant='body2' fontWeight='medium'>
                            {t('Inventory {{inventoryDate}}', { inventoryDate: dateTimeService.localizeDate(endDate, cultureCode) })}
                        </Typography>
                        {UnicodeEntity.NoBreakSpace}
                        {UnicodeEntity.NoBreakSpace}
                        <Typography variant='body2'>
                            {priceService.toLocaleString(delta, currencyCode)}
                        </Typography>
                    </Box>
                )

                ): null}
        </AccordionRow>
    );
};

export default InventoryCountsSummary;